/**
 * 바이트 크기를 사람이 읽는 꼴로 — 상한 안내(올리기·첨부·결과 화면)가 모두 이것으로 적는다.
 */
export const MIB = 1024 * 1024;

/** MiB 로, 소수 첫째 자리까지 올림 — 상한을 조금 넘은 크기가 상한과 같은 수로 보이지 않게(64 MiB + 1 B → «64.1 MiB») */
export function mibLabel(bytes: number): string {
  return `${Math.ceil((bytes / MIB) * 10) / 10} MiB`;
}
